import AddInsuranceCardModal from "./AddInsuranceCardModal";

export default AddInsuranceCardModal;

export * from "./AddInsuranceCardModal";
